import { _patientUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

const healthcareUpdate = createAsyncThunk('healthcareUpdate', async (data: any) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  try {
    let url = _patientUrls.healthcareUpdate
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default healthcareUpdate;
